import { FC } from 'react';
import { Box, Typography } from '@mui/material';
import OtherSectionFilter from '../List/filter/OtherSectionFilter';
import { Filters } from 'framework/list';

interface OtherSectionHeaderProps {
  isPolishContractor?: boolean;
}

const OtherSectionHeader: FC<OtherSectionHeaderProps> = ({ isPolishContractor = false }) => {
  return (
    <Box display="flex" justifyContent="space-between" width="100%">
      <Typography variant="h4" color="primary">
        {isPolishContractor ? 'Unpaid Leaves' : 'Other'}
      </Typography>
      <Box>
        <Filters>
          <OtherSectionFilter />
        </Filters>
      </Box>
    </Box>
  );
};

export default OtherSectionHeader;
